import { render, staticRenderFns } from "./PopupEditSetupFloorplan.vue?vue&type=template&id=c876237c&scoped=true&"
import script from "./PopupEditSetupFloorplan.vue?vue&type=script&lang=js&"
export * from "./PopupEditSetupFloorplan.vue?vue&type=script&lang=js&"
import style0 from "./PopupEditSetupFloorplan.vue?vue&type=style&index=0&id=c876237c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c876237c",
  null
  
)

export default component.exports